import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    stroke="currentColor"
    strokeWidth="2"
    d="M20.587 7.677c.125-.39 0-.677-.596-.677h-1.969c-.5 0-.731.248-.856.521 0 0-1.002 2.283-2.42 3.766-.46.43-.668.566-.918.566-.126 0-.307-.136-.307-.526v-3.65c0-.468-.145-.677-.562-.677H9.864c-.313 0-.501.217-.501.423 0 .444.71.547.782 1.796v2.713c0 .594-.114.702-.365.702-.667 0-2.291-2.293-3.254-4.918C6.337 7.206 6.148 7 5.644 7H3.675C3.113 7 3 7.248 3 7.521c0 .488.668 2.908 3.108 6.108C7.736 15.815 10.028 17 12.115 17c1.251 0 1.406-.263 1.406-.716v-1.652c0-.527.119-.632.515-.632.292 0 .793.137 1.961 1.19 1.335 1.25 1.555 1.81 2.307 1.81h1.969c.562 0 .844-.263.681-.782-.177-.518-.815-1.269-1.66-2.16-.46-.507-1.148-1.053-1.357-1.326-.292-.352-.208-.508 0-.82 0 0 2.4-3.162 2.65-4.235Z"
    clipRule="evenodd"
    fill="none"
  />,
  'Vk'
)
